import { useTheme } from "../contexts/ThemeContext";
import "./DarkModeToggle.css";

function SunIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <circle cx="12" cy="12" r="4.5" fill="#f59e0b" />
      <g stroke="#f59e0b" strokeWidth="1.8" strokeLinecap="round">
        <line x1="12" y1="2.5" x2="12" y2="5" />
        <line x1="12" y1="19" x2="12" y2="21.5" />
        <line x1="2.5" y1="12" x2="5" y2="12" />
        <line x1="19" y1="12" x2="21.5" y2="12" />
        <line x1="5.3" y1="5.3" x2="7.1" y2="7.1" />
        <line x1="16.9" y1="16.9" x2="18.7" y2="18.7" />
        <line x1="5.3" y1="18.7" x2="7.1" y2="16.9" />
        <line x1="16.9" y1="7.1" x2="18.7" y2="5.3" />
      </g>
    </svg>
  );
}

function MoonIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path
        d="M15.5 4.2a7.5 7.5 0 1 0 4.3 13.6A6.2 6.2 0 0 1 15.5 4.2Z"
        fill="#cbd5e1"
        stroke="#94a3b8"
        strokeWidth="0.6"
      />
    </svg>
  );
}

export default function DarkModeToggle({ className = "", compact = true }) {
  const { isDark, toggleTheme } = useTheme();

  return (
    <button
      type="button"
      className={`theme-switch ${isDark ? "is-dark" : "is-light"} ${
        compact ? "theme-switch-compact" : ""
      } ${className}`.trim()}
      onClick={toggleTheme}
      role="switch"
      aria-checked={isDark}
      aria-label={isDark ? "Switch to day mode" : "Switch to night mode"}
      title={isDark ? "Night mode" : "Day mode"}
    >
      <span className="theme-switch-track">
        {!compact && (
          <span className="theme-switch-label">
            {isDark ? "Night Mode" : "Day Mode"}
          </span>
        )}
        <span className="theme-switch-thumb">
          {isDark ? <MoonIcon /> : <SunIcon />}
        </span>
      </span>
    </button>
  );
}
